<div #originRef
     (click)="showPopover(originRef)"
     [class.bg-hover]="dropdownOpen"
     class="flex items-center rounded cursor-pointer relative trans-ease-out select-none py-1 pr-1 pl-3 hover:bg-hover"
     matRipple>

  <!-- First name (from JWT, shown immediately) -->
  <div class="body-1 font-medium leading-snug mr-3 hidden sm:block">{{ firstName }}</div>

  <!-- Avatar: photo if loaded, otherwise person icon -->
  <div class="rounded-full h-9 w-9 flex items-center justify-center overflow-hidden bg-primary-light flex-shrink-0">
    <ng-container *ngIf="(userProfileService.profile$ | async) as profile">
      <img *ngIf="profile.photoUrl"
           [src]="profile.photoUrl"
           alt="Profile photo"
           class="w-full h-full object-cover rounded-full" />
      <iconify-icon *ngIf="!profile.photoUrl"
                    [icon]="icPerson"
                    class="text-primary"
                    width="24" height="24"></iconify-icon>
    </ng-container>
    <ng-container *ngIf="!(userProfileService.profile$ | async)">
      <iconify-icon [icon]="icPerson"
                    class="text-primary"
                    width="24" height="24"></iconify-icon>
    </ng-container>
  </div>

</div>
